type Props = { price?: string; pricePerCard?: string; additionalInfo?: string };

const TabledContent = ({ price, pricePerCard, additionalInfo }: Props) => (
  <div className="flex flex-col text-neutral-50">
    <div>
      {price && <span className="font-bold">{price}</span>}
      {pricePerCard && <span className="text-sm ml-2 text-gold-100">{pricePerCard}</span>}
    </div>
    {additionalInfo && <span className="text-sm">{additionalInfo}</span>}
  </div>
);

export default TabledContent;
